import React from 'react';
import {
  ReferenceArrayField,
  SingleFieldList,
  RecordContextProvider,
  SelectField,
  TextField,
  usePermissions,
} from 'react-admin';

import { Box } from '@mui/material';

import { ruleNameChoices } from '../../ruleFeatures';
import ColoredChipField from '../../../../customFields/ColoredChipField';
import { Rule } from '../../../../utilities/schemas/rules';
import hasAccess from '../../../../utilities/hasAccess';
import actions, { Actions } from '../../../../constants/actions';

const Title = ({ rule }: { rule?: Rule }) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <RecordContextProvider value={rule}>
      <Box display="flex" flexDirection="row" alignItems="flex-start" gap={2}>
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row">
            <TextField sx={{ fontWeight: 'bold', marginRight: 2 }} source="customName" />
            {hasAccess(permissions, actions.TAG_LIST) && (
              <ReferenceArrayField source="tags" reference="tags" label="Tags" emptyText="-">
                <SingleFieldList placeholder="-">
                  <ColoredChipField small />
                </SingleFieldList>
              </ReferenceArrayField>
            )}
          </Box>
          <SelectField source="name" choices={ruleNameChoices} />
        </Box>
      </Box>
    </RecordContextProvider>
  );
};

export default Title;
